import { useMemo, useContext, useState, useEffect } from 'react';

import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';

import { UserContext } from '../../Contexts/UserContext';
import { ACCESS_CONTROL_CONSTANTS } from '../../core/constants';
import styles from './styles';
const { SYSTEMS, UI_ACCESS, TYPES } = ACCESS_CONTROL_CONSTANTS;

const GeneralTab = ({
	tabListAndPanels = [],
	tabListStyles = {},
	tabListProps = {},
	system = SYSTEMS.FRAMERATE
}) => {
	const [pageName, setPageName] = useState(null);
	const { getAccessControlSet } = useContext(UserContext);
	const classes = styles();

	let filteredTabListAndPanels = useMemo(() => {
		const tabsFilteredBasedOnAcessControl = tabListAndPanels.filter((data) => {
			const accessControlSetForTab = getAccessControlSet(
				system,
				TYPES.TAB_NAMES,
				data?.tab?.props?.value
			);
			if (!accessControlSetForTab.has(UI_ACCESS.HIDE)) {
				return true;
			}
			return false;
		});
		return tabsFilteredBasedOnAcessControl;
	}, [tabListAndPanels, getAccessControlSet, system]);

	useEffect(() => {
		if (filteredTabListAndPanels.length > 0 && !pageName) {
			setPageName(filteredTabListAndPanels[0]?.tab?.props?.value);
		}
	}, [filteredTabListAndPanels]);

	const tabListClasses =
		tabListAndPanels.length === 1 ? `${classes.tabList} ${classes.singularTab}` : classes.tabList;

	return (
		<TabContext value={pageName}>
			<TabList
				onChange={(event, newValue) => {
					setPageName(newValue);
				}}
				className={tabListClasses}
				style={tabListStyles}
				{...tabListProps}
			>
				{filteredTabListAndPanels.map((data) => data.tab)}
			</TabList>
			{filteredTabListAndPanels.map((data) => data.tabPanel)}
		</TabContext>
	);
};

export default GeneralTab;
